const ErrorConstants = {
  SET_ERROR: 'SR_SET_ERROR',
  CLEAR_ERROR: 'SR_CLEAR_ERROR',
  SET_WARNING: 'SR_SET_WARNING',
  CLEAR_WARNING: 'SR_CLEAR_WARNING'
};

export default ErrorConstants;
